namespace RedBullMOBILE360.Web.Modules.Utilities.ReAuthenticateMsisdn {
    export interface CreateReAuthLinkRequest extends Serenity.ServiceRequest {
        msisdn?: string;
    }
}
